import { ChoicesArticleCombinationImage } from "@generated"
import React, { FC } from "react"
import * as S from "./Images.elements"
import imgix from "@config/imgix"

type RelatedCombinationCardImagesProps = {
  images: ChoicesArticleCombinationImage[]
}

export const RelatedCombinationCardImages: FC<
  RelatedCombinationCardImagesProps
> = ({ images }) => {
  const productImage = images
    ? imgix({
        key: images[0].path.replace(".png", ""),
        type: "articleCombination",
        args: {
          w: 500,
          h: 500,
        },
      })
    : undefined
  const displayImage =
    images && images[1]
      ? imgix({
          key: images[1].path.replace(".png", ""),
          type: "articleCombination",
          args: {
            w: 500,
            h: 500,
          },
        })
      : undefined

  return (
    <>
      {productImage && (
        <S.ProductImage
          data-product-image
          alt="Interchangeable jewelry"
          src={productImage}
          imageSize="large"
        />
      )}
      {displayImage && <S.HoverImage data-hover-image src={displayImage} />}
    </>
  )
}
